import { render, staticRenderFns } from "./judgementDocument.vue?vue&type=template&id=3a8b05d8&scoped=true&"
import script from "./judgementDocument.vue?vue&type=script&lang=js&"
export * from "./judgementDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8b05d8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/site-front-pipline/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a8b05d8')) {
      api.createRecord('3a8b05d8', component.options)
    } else {
      api.reload('3a8b05d8', component.options)
    }
    module.hot.accept("./judgementDocument.vue?vue&type=template&id=3a8b05d8&scoped=true&", function () {
      api.rerender('3a8b05d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/workplace/components/company/judgementDocument.vue"
export default component.exports